import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './app/containers/App/App';
import { queryClient } from './queryClient';
import * as Sentry from '@sentry/react';
import config from './config';
// DO NOT DELETE - these polyfills are required to support stringifying of a map or a set
// (JSON.stringify(new Map()) is [] instead of {})
import 'core-js/fn/map';
import 'core-js/fn/set';
import 'core-js/fn/weak-map';
import { isLocalhost } from 'shared/utils/sharedUtils.js';
import { configure } from 'mobx';

// eslint-disable-next-line no-console
const originalError = console.error;
// eslint-disable-next-line no-console
console.error = (...args) => {
  const str = args?.join(' ');
  if (str?.includes?.('Support for defaultProps will be removed from')) {
    // eslint-disable-next-line no-console
    console.log('Support for defaultProps warning ignored');
    return;
  }
  if (str?.includes?.('Invalid prop') && str?.includes?.('@pileus-cloud_anodot-frontend-common')) {
    // eslint-disable-next-line no-console
    console.log('Invalid prop warning ignored');
    return;
  }

  if (str?.includes?.('Failed %s type')) {
    // eslint-disable-next-line no-console
    console.log('Failed prop type ignored');
    return;
  }
  originalError.apply(console, args);
};

// eslint-disable-next-line no-console
const originalWarn = console.warn;
// eslint-disable-next-line no-console
console.warn = (...args) => {
  const str = args?.join(' ');
  if (str?.includes?.('Support for defaultProps will be removed from')) {
    // eslint-disable-next-line no-console
    console.log('Support for defaultProps warning ignored');
    return;
  }
  if (str?.includes?.('Invalid prop') && str?.includes?.('@pileus-cloud_anodot-frontend-common')) {
    // eslint-disable-next-line no-console
    console.log('Invalid prop warning ignored');
    return;
  }

  if (str?.includes?.('Failed %s type')) {
    // eslint-disable-next-line no-console
    console.log('Failed prop type ignored');
    return;
  }
  originalWarn.apply(console, args);
};

// Configure MobX to isolate its internal state
configure({
  isolateGlobalState: true,
});
Sentry.init({
  dsn: 'https://a411162d6235a66ff6d0c0cb7edc07ab@o4509110613770240.ingest.de.sentry.io/4509110615801936',
  environment: config.env,
  ignoreErrors: ['Non-Error promise rejection captured', 'AxiosError'],
  enabled: !isLocalhost(),
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Router>
    <QueryClientProvider client={queryClient}>
      <App queryClient={queryClient} />
    </QueryClientProvider>
  </Router>,
);
